import { getUserInfo } from 'pwa-mmt-ui-header/ssr/header';
import { getUserInfoPIIClient } from 'MMT-UI/getPIIData/client';
import { getAuthToken, isHEMmtDomain } from './appUtils';
import { isAgentLoggedIn } from './browserUtils';

function isUserLoggedIn() {
  return !!getAuthToken();
}

const getUserInfoFromServer = () => {
  if (isUserLoggedIn()) {
    return ssr.isOnClient ? getUpdatedUserinfo(userInfoFromServer || {}) : {};
  }
  return null;
};

const getUpdatedUserinfo = userInfoFromServer => {
  if (userInfoFromServer?.miscFields?.heAgentInfo) {
    const heAgentInfo = JSON.parse(userInfoFromServer?.miscFields?.heAgentInfo);
    if (heAgentInfo?.agentId) {
      return {
        ...userInfoFromServer,
        profileType: 'AGENT',
      };
    }
  }
  return userInfoFromServer;
};

const checkIfHeAgentError = () => {
  const isAgent = isAgentLoggedIn();
  if (isHEMmtDomain() && !isAgent) {
    return true;
  }
  return false;
};

const getUserInfoFromClient = async () => {
  try {
    if (isUserLoggedIn() && ssr.isOnClient) {
      const userData = await getUserInfoPIIClient();
      return getUpdatedUserinfo(userData);
    }
    return null;
  } catch (e) {
    return null;
  }
};

export { getUserInfoFromServer, getUserInfoFromClient, checkIfHeAgentError };
